import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

// ✅ Get All How It Works
export const getHowItWorks = createAsyncThunk(
  "admin/allHowItWorks",
  async ({ page, limit, searchData }, { rejectWithValue }) => {
    try {
      let url = `/how-it-work/all?page=${page}&limit=${limit}`;
      if (searchData) {
        url += `&search=${searchData}`;
      }
      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// ✅ Add How It Work
export const addHowItWork = createAsyncThunk(
  "admin/addHowItWork",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/how-it-work/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// ✅ Edit How It Work
export const editHowItWork = createAsyncThunk(
  "admin/editHowItWork",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/how-it-work/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// ✅ Get Single How It Work
export const getSingleHowItWork = createAsyncThunk(
  "admin/singleHowItWork",
  async (howItWorkId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/how-it-work/${howItWorkId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// ✅ Delete How It Work
export const deleteHowItWork = createAsyncThunk(
  "admin/deleteHowItWork",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(`/how-it-work/delete/${selectedId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

const initialState = {
  howItWorkData: [],
  singleHowItWorkData: [],
};

const howItWorkSlice = createSlice({
  name: "howItWorkSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHowItWorks.fulfilled, (state, action) => {
      state.howItWorkData = action.payload.data;
    });
    builder.addCase(getSingleHowItWork.fulfilled, (state, action) => {
      state.singleHowItWorkData = action.payload.data;
    });
  },
});

export default howItWorkSlice.reducer;
